// extracted by mini-css-extract-plugin
export var link = "styles-module--link--kBMUn";
export var linkNav = "styles-module--link-nav--yztFw";
export var linkBlue = "styles-module--link-blue--z+848";
export var linkWhite = "styles-module--link-white--w1yhF";